import type { ReactNode } from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Disabled = styled2.span<{
	children?: ReactNode;
}>({
	color: token('color.text.disabled'),
	opacity: 0.5,
	cursor: 'not-allowed',
});

// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FieldNameWrapper = styled.div<{
	children?: ReactNode;
}>({
	flexGrow: 1,
	flexShrink: 1,
	flexBasis: '10em',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
});
